<template>
  <div class="page">
    <div class="hd">
      <router-link to="/">
        <img class="logo" src="../../assets/logo.png" alt="logo" />
      </router-link>
      <router-link v-if="searchable" to="/search" class="search">
        <span class="iconfont iconsearch"></span>
      </router-link>
    </div>
    <slot></slot>
    <slot name="ft"></slot>
  </div>
</template>
<script>
export default {
  props: { searchable: { type: Boolean, default: true } },
};
</script>
<style src="./_layout.css" />;
